import { useForm } from 'react-hook-form';
import { ProgramSettingsFormValues } from '@/types/setting';
import { mapProgramSettingsToFormValues } from '@/utils/programSettingsFormMapper';
import {
  useFetchProgramSettings,
  useProgramSettings,
} from '@/hooks/requests/useSettings';
import { useScrollToTop } from '@/hooks/useScrollToTop';
import { logAnalyticsEvent } from '@/utils/analytics';
import showToast from '@/utils/toast';
import { MESSAGES } from '@/constants/messages';

export function useProgramSettingsForm() {
  const { data: programSettings } = useFetchProgramSettings();
  const { updateProgramSettings } = useProgramSettings();
  const { scrollToTop } = useScrollToTop();

  const formValues = mapProgramSettingsToFormValues(programSettings);

  const formMethods = useForm<ProgramSettingsFormValues>({
    defaultValues: formValues,
    values: formValues,
    mode: 'onBlur',
  });

  const handleSubmitSetting = async (data: ProgramSettingsFormValues) => {
    try {
      await updateProgramSettings(data);
      showToast({
        type: 'success',
        data: {
          content: 'Your program settings have been successfully updated',
        },
      });
      logAnalyticsEvent({
        category: 'success',
        action: 'updateSettingsComplete',
      });
      scrollToTop();
    } catch {
      logAnalyticsEvent({
        category: 'error',
        action: 'updateSettingsError',
      });
      showToast({
        type: 'error',
        data: { content: MESSAGES.genericError },
      });
    }
  };

  return {
    formMethods,
    handleSubmitSetting,
    programSettings,
    isFormDirty: formMethods.formState.isDirty,
  };
}
